export default {"src":"/_next/static/media/chevron_down.c0e5e7f5.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};